import React, { createContext, useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'

// หน้าที่มีกราฟต้องรู้ว่าตอนนี้เป็นโหมดมืดไหม เพื่อเลือกชุดสีให้ตรงกับพื้นหลัง
// Header เป็นตัวสลับ แต่เป็นลูกของ layout จึงส่งค่าลงมาทาง context
// ดีกว่าให้แต่ละหน้าไปนั่ง poll localStorage เอง
const SkinContext = createContext(false)
export const useDarkSkin = () => useContext(SkinContext)

// เปลือกหน้าเว็บของโมดูลรับสมัคร
//
// ทุกหน้าในระบบทำสามอย่างเดียวกันเสมอ: สลับ skin, วาง Header/Footer, ทำ breadcrumb
// หน้าอื่นๆ คัดลอกบล็อก switchSkin กันมาทั้งก้อน — โมดูลนี้รวบไว้ที่เดียว
// เพื่อไม่ให้เพิ่มสำเนาของบล็อกนั้นอีกห้าชุด

export default function AdmissionLayout({ title, breadcrumb = [], actions, children }) {
  const [skin, setSkin] = useState(localStorage.getItem('skin-mode') ? 'dark' : '')

  useEffect(() => {
    const tables = document.getElementsByTagName('table')
    for (const table of tables) {
      const theads = table.querySelectorAll('thead')
      if (skin === 'dark') {
        table.classList.add('table-dark')
        for (const thead of theads) {
          thead.classList.remove('table-secondary')
          thead.classList.add('table-primary')
        }
      } else {
        table.classList.remove('table-dark')
        for (const thead of theads) {
          thead.classList.remove('table-primary')
          thead.classList.add('table-secondary')
        }
      }
    }
  }, [skin, children])

  return (
    <SkinContext.Provider value={skin === 'dark'}>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link to="#">งานรับสมัคร</Link></li>
              {breadcrumb.map((item, i) => (
                <li
                  key={item.label}
                  className={`breadcrumb-item${i === breadcrumb.length - 1 ? ' active' : ''}`}
                  aria-current={i === breadcrumb.length - 1 ? 'page' : undefined}
                >
                  {item.to ? <Link to={item.to}>{item.label}</Link> : item.label}
                </li>
              ))}
            </ol>
            <h4 className="main-title mb-0">{title}</h4>
          </div>
          {actions && <div className="d-flex align-items-center gap-2 mt-3 mt-md-0">{actions}</div>}
        </div>

        {children}

        <Footer />
      </div>
    </SkinContext.Provider>
  )
}
